import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as spaceLite from '../space-lite'

export const RESOURCE = {
  payload: {
    alias: 'space-lite:survey-configuration',
    appAlias: spaceLite.RESOURCE.payload.alias,
    description:
      'Manage the unlock-rooms survey tool for the current scenario in Space Lite',
    display: {
      isMain: false,
      position: 1,
    },
    name: 'Survey Configuration',
    page: { id: prebuilt.Page.Id.SpaceLiteSurveyConfiguration },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
